import { SxProps } from "@mui/material";

export const hideNoChildSX: SxProps = {
	'&:empty': {
		display: 'none',
	},
};